import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { CalendarEventType } from '../../types/calendar';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import MedicationIcon from '@mui/icons-material/Medication';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';

// Helper component to render the correct icon based on event type
const EventTypeIcon = ({ eventType }: { eventType: CalendarEventType }) => {
    if (!eventType) {
        return <EventIcon />;
    }
    switch (eventType.code) {
        case 'food':
            return <RestaurantMenuIcon />;
        case 'workout':
            return <FitnessCenterIcon />;
        case 'medication':
            return <MedicationIcon />;
        case 'feeling':
            return <SentimentSatisfiedAltIcon />;
        case 'task':
            return <TaskAltIcon />;
        case 'consultation':
            return <PeopleIcon />;
        default:
            return <EventIcon />;
    }
};

interface EventTypesTabProps {
  eventTypes: CalendarEventType[];
}

export const EventTypesTab: React.FC<EventTypesTabProps> = ({ eventTypes }) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <List>
        {eventTypes.map(type => (
          <ListItem key={type.id}>
            <ListItemIcon>
              <EventTypeIcon eventType={type} />
            </ListItemIcon>
            <ListItemText primary={type.name} secondary={`Code: ${type.code}`} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};
